import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Slide, styled } from "@mui/material";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { SignUpWidget } from "user-management/src/components/signUpWidget";
import { LoginWidget } from "user-management/src/components/loginWidget";
import { NewPasswordWidget } from "user-management/src/components/newPasswordWidget";
import { Logout } from "user-management/src/components/logout";
import { DemoLanding } from "./demoLanding";
import { LandingPageLayout } from "fe-web-components/layout/landingPageLayout";
import {
  isValidSession,
  refreshSession,
} from "user-management/src/cognito/kahunUserAuth";
import { UserAuthenticationWrapper } from "./userAuthenticationWrapper";

//region [[ Styles ]]
const DemoPageLayout = styled(LandingPageLayout)({
  "& .content-view": {
    alignItems: "center",
    boxSizing: "border-box",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]
export interface DemoSignupState {
  signupCohort?: string;
  role?: string;
}

export interface DemoRouterProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DemoRouter = ({ ...props }: DemoRouterProps) => {
  const history = useHistory();

  const [isLoggedIn, setLoggedIn] = useState(false);

  // useEffect(() => {
  //   (async () => {
  //     const isValid = await isValidSession();
  //     setLoggedIn(isValid);
  //   })();
  // }, [history]);

  /** if we have a session, just refresh and move on */
  useEffect(() => {
    (async () => {
      const isvalid = await isValidSession();
      if (isvalid) {
        console.log("already logged in - refreshing");
        const refreshed = await refreshSession();
        if (refreshed) {
          //history.push("/welcome");
          setLoggedIn(true);
        }
      }
    })();
  }, [history, setLoggedIn]);

  const location = useLocation<DemoSignupState>();

  const signupCohort = location?.state?.signupCohort || "demolink";

  const role = location?.state?.role || "demo_users";

  const match = useRouteMatch();
  // Clean "/" from path in the end if exists
  const matchPath = removeTrailingSlash(match.path);

  const pathForRoute = useCallback((path) => `${matchPath}/${path}`, [
    matchPath,
  ]);

  const handleTryItClick = () => {
    if (isLoggedIn) {
      history.push("/welcome");
    } else history.push(pathForRoute("signup"));
  };

  const toNavigationRoute = useCallback(
    (path, component) => (
      <Route
        key={path}
        path={pathForRoute(path)}
        exact
        render={() => (
          <Slide
            style={{ display: "flex", flex: 1 }} // Make it flex-grow inside the parent space
            direction={"down"}
            in
            mountOnEnter
            unmountOnExit
          >
            <div>{component}</div>
          </Slide>
        )}
      />
    ),
    [pathForRoute],
  );

  const customFields = {};

  if (signupCohort) customFields["custom:signupCohort"] = signupCohort;

  if (role) customFields["custom:signupRole"] = role;

  const clientData = role ? { role } : null;

  return (
    <DemoPageLayout onHome={() => history.push(pathForRoute("/"))}>
      <Switch>
        {toNavigationRoute(
          "signup",
          <UserAuthenticationWrapper subtitle={"Sign up"}>
            <SignUpWidget
              hideLogo
              onSignUpComplete={() => history.push("login")}
              onLoginClick={() => history.push("login")}
              customClientData={clientData}
              customFields={customFields}
            />
          </UserAuthenticationWrapper>,
        )}
        {toNavigationRoute(
          "login",
          <UserAuthenticationWrapper subtitle={"Login"}>
            <LoginWidget
              hideLogo
              onSignIn={() => history.push("/welcome")}
              onForgotPasswordClick={() => history.push("forgot_password")}
              onSignUpClick={() => history.push("signup")}
            />
          </UserAuthenticationWrapper>,
        )}
        {toNavigationRoute(
          "forgot_password",
          <UserAuthenticationWrapper subtitle={"Reset Password"}>
            <NewPasswordWidget
              hideLogo
              onResetComplete={() => history.push("login")}
            />
          </UserAuthenticationWrapper>,
        )}
        {toNavigationRoute(
          "logout",
          <Logout>
            <Redirect to={pathForRoute("/")} />
          </Logout>,
        )}
        <Route
          path="/"
          render={() => (
            <DemoLanding
              onTryItClick={handleTryItClick}
              isLoggedIn={isLoggedIn}
            />
          )}
        />
      </Switch>
    </DemoPageLayout>
  );
};
